/** @module Enums */ /** typedoc */

/**
 * This Enum purpose is to regroup ReleasePayoutStatus in a few categories.
 *
 * https://github.com/Mixgenius/LANDR.Distribution/blob/master/src/LANDR.Distribution/Services/Payouts/PayoutStatusEnum.cs
 */
export enum ReleasePayoutGlobalStatusEnum {
    Completed = 'Completed',
    Pending = 'Pending',
    Error = 'Error'

}
